<cll-dialog-layout>
    <cll-dialog-header>
        <cll-dialog-title>Edit position</cll-dialog-title>
        <cll-dialog-subtitle>
            @if (commissionerUser.user.person) {
                For {{ commissionerUser.user.person.given_name }} {{ commissionerUser.user.person.family_name }}
            }
        </cll-dialog-subtitle>
    </cll-dialog-header>
    @if (commissionerUser) {
        <div class="dialog-detail" [formGroup]="commissionerUserDetailsFormGroup">
            <cll-form-field [label]="'Select a position'">
                <select formControlName="position" cllFormInput>
                    <option value="Commissioner Admin">Commissioner admin</option>
                    <option value="Commissioner User">Commissioner user</option>
                </select>
            </cll-form-field>
            <span class="dialog-divider"></span>
            <cll-dialog-footer>
                @if (updateCommissionerUserRequest.error(); as error) {
                    <app-error-panel [error]="error" />
                }

                <button cll-button
                        colour="variant"
                        cllDialogClose>
                    Cancel
                </button>
                <button cll-filled-button
                        colour="secondary"
                        [disabled]="commissionerUserDetailsFormGroup.invalid || updateCommissionerUserRequest.loading()"
                        (click)="update()">
                    Save
                </button>
            </cll-dialog-footer>
        </div>
    }
</cll-dialog-layout>
